/** File-format badge used by compact document download actions. */
export default function DocumentFormatIcon({ format }: { format: 'pdf' | 'docx' }) {
  return <svg aria-hidden="true" viewBox="0 0 28 30" className={`h-8 w-8 ${format === 'pdf' ? 'text-red-700' : 'text-blue-700'}`} fill="none">
    <path d="M17 2H7a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h15a2 2 0 0 0 2-2V9L17 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M17 2v7h7" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    <rect x="1" y="13" width="26" height="11" rx="2" fill="currentColor" />
    <text x="14" y="21" fill="white" fontFamily="Arial, sans-serif" fontSize="8" fontWeight="700" textAnchor="middle">{format === 'pdf' ? 'PDF' : 'DOC'}</text>
  </svg>;
}
